import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ allowedRoles, element: Component, ...rest }) => {
  const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';

  if (!Component) {
    return <Navigate to="/login" replace />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  if (
    Array.isArray(allowedRoles)
    && !allowedRoles.includes(Number(sessionStorage.getItem('role_id')))
  ) {
    return <Navigate to="/clients" replace />;
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
